export default "__VITE_ASSET__DNFgALg$__"